import React, { useMemo, useContext } from 'react';
import NestingaleConfigJson from './config.json';
//import { ConfigContext } from '../pages/App';
import rowConfig from './config.json';


type ConfigKey =
    | 'default'
    | 'local'
    | 'dev'
    | 'stage'
    | 'production'

export type ConfigValue =
    | string
    | boolean
    | number
    | string[]
    | { [key: string]: ConfigValue }
    | { [key: string]: ConfigValue }[];

type ConfigEntry = {
    [key in ConfigKey]?: ConfigValue;
};

const configuraton = {
    nestingale: NestingaleConfigJson
}

export type Config = Map<string, ConfigEntry>;

export function parseConfig(rawConfig: { [key: string]: ConfigEntry }): Config {
    return new Map(
        Object.keys(rawConfig).map((key: string) => [key, rawConfig[key]]),
    );
}

export function getConfigValue(
    key: string,
    config: Config,
): ConfigValue | undefined {
    const entry = config.get(key);

    if (!entry) {
        // No config entry, undefined value
        return undefined;
    }
    // Use the default value
    return entry.default;
}

//export const ConfigContext = React.createContext(new Map());

const brand = "nestingale"; // TODO : Need to get this from global request

const config = {
    "showWegGL": true,
    "currentBrand": brand,
    "siteConfig": parseConfig(rowConfig)
  }

 export default function useConfigValue(
    key: string,
    defaultValue?: ConfigValue,
): ConfigValue | undefined {
    //const config = useContext(ConfigContext);
    return useMemo(() => {
        const val = getConfigValue(key, config.siteConfig);
        return val === undefined ? defaultValue : val;
    }, [key, config, defaultValue]);
} 
